var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.$t("shipmentErrors.title")) + " "),
              _c("v-spacer"),
              _c("v-select", {
                staticStyle: { "max-width": "260px" },
                attrs: {
                  items: _vm.errorReasonOptions,
                  label: _vm.$t("shipmentErrors.filterByReason"),
                  clearable: "",
                  dense: "",
                  outlined: "",
                  "hide-details": "",
                },
                on: { change: _vm.onFilterChange },
                model: {
                  value: _vm.reasonFilter,
                  callback: function ($$v) {
                    _vm.reasonFilter = $$v
                  },
                  expression: "reasonFilter",
                },
              }),
            ],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.shipments,
              options: _vm.options,
              "server-items-length": _vm.totalCount,
              loading: _vm.loading,
              "footer-props": { itemsPerPageOptions: [10, 20, 50] },
            },
            on: {
              "update:options": [
                function ($event) {
                  _vm.options = $event
                },
                _vm.fetchShipments,
              ],
            },
            scopedSlots: _vm._u([
              {
                key: "item.errorReason",
                fn: function ({ item }) {
                  return [
                    _c(
                      "v-chip",
                      {
                        attrs: {
                          small: "",
                          color: _vm.reasonColor(item.errorReason),
                          "text-color": "white",
                        },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.reasonLabel(item.errorReason)) + " "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "item.updateDate",
                fn: function ({ item }) {
                  return [
                    _vm._v(" " + _vm._s(_vm.formatDate(item.updateDate)) + " "),
                  ]
                },
              },
              {
                key: "no-data",
                fn: function () {
                  return [
                    _c("div", { staticClass: "text-center py-6" }, [
                      _vm._v(
                        " " + _vm._s(_vm.$t("shipmentErrors.noData")) + " "
                      ),
                    ]),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }